import { ICategoryChartParams } from 'common/utils/chart/chartUtils'
import {
  group1ColourScheme,
  group2ColourScheme,
  group3ColourScheme,
  group4ColourScheme,
  QRABarColorScheme
} from 'common/utils/colorUtils'

import tailwind from '_/tailwind.config'

export interface IBaseBarChartConfigParams extends ICategoryChartParams {
  valueAxisLabel?: string
  colorScheme?: QRABarColorScheme
  stacked?: boolean
}

const barColorSchemes: Record<QRABarColorScheme, string[]> = {
  [QRABarColorScheme.RISK_BY_LINE]: [
    tailwind.theme.colors.lighthouseBlue.DEFAULT,
    tailwind.theme.colors.lighthouseBlue[100]
  ],
  [QRABarColorScheme.THREATS]: [
    tailwind.theme.colors.blue.navy,
    tailwind.theme.colors.blue[700]
  ],
  [QRABarColorScheme.CONSEQUENCES]: [
    tailwind.theme.colors.lightBlue[650],
    tailwind.theme.colors.green.DEFAULT
  ],
  [QRABarColorScheme.RISK_FORECAST_GROUP_1]: group1ColourScheme,
  [QRABarColorScheme.RISK_FORECAST_GROUP_2]: group2ColourScheme,
  [QRABarColorScheme.RISK_FORECAST_GROUP_3]: group3ColourScheme,
  [QRABarColorScheme.RISK_FORECAST_GROUP_4]: group4ColourScheme
}

export const getBarColorScheme = (
  colorScheme: QRABarColorScheme = QRABarColorScheme.RISK_BY_LINE
): string[] => {
  return barColorSchemes[colorScheme]
}
